module.exports = __webpack_public_path__ + "img/it.d7f63251.svg";